if (!customElements.get('blog-showcase-carousel')) {
  customElements.define(
    'blog-showcase-carousel',
    class extends HTMLElement {
      connectedCallback() {
        this._carousel = this.querySelector('[data-carousel]');
        this._fill = this.querySelector('[data-progress-fill]');
        if (!this._carousel || !this._fill) return;
        this._carousel.addEventListener('scroll', () => this._update(), { passive: true });
        this._update();
      }

      _update() {
        const { scrollLeft, scrollWidth, clientWidth } = this._carousel;
        const pct = scrollWidth > 0 ? ((scrollLeft + clientWidth) / scrollWidth) * 100 : 0;
        this._fill.style.width = `${Math.min(pct, 100)}%`;
      }
    }
  );
}
